/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auto_RefreshInputs */



/**
* | output |
* | --- |
* | "Auto Refresh" |
*
* @param {Auto_RefreshInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const auto_refresh = /** @type {((inputs?: Auto_RefreshInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auto_RefreshInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rafraîchissement auto")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatische Aktualisierung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiornamento automatico")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автоматическое обновление")
	if (locale === "es") return /** @type {LocalizedString} */ ("Actualización automática")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动刷新")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動更新")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑटो रिफ्रेश")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atualização automática")
	return /** @type {LocalizedString} */ ("Auto Refresh")
});